import { Location } from '@angular/common';
import { Component, ElementRef, Input, ViewContainerRef, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Auth, Configuration, HttpClientCustom } from '../../shared';
import { SharedData } from '../../shared/sharedData';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';

@Component({
    selector: "editNotificationLang",
    templateUrl: "editNotificationLangComponent.html"
})
export class EditNotificationLangComponent {

    @Input()
    public notificationLang: any = {};
    public variables: any[] = [];
    public locals: any[] = [];
    @Output() triggerSave = new EventEmitter();
    @Output() cancel = new EventEmitter();
    @Input()
    public eventId: number;
    public _baseUrl: string;
    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public _http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public translate: TranslateService) {
        this._baseUrl = _global.get('EPMS_BASE_URL');
        this._toaster.setViewRef(vcr);
        this.getAllLang();
    }


    public loadEventVariableByEventId() {
        if (this.eventId) {
            let url = this._baseUrl + 'v1/webAdmin/notification/loadVariables/' + this.eventId;
            let self = this;
            self._http.get(url).subscribe((result) => {
                self.variables = result;
            }, (error) => {
                this._toaster.showError("Not able to fetch notification");
            });
        }
    }

    public getAllLang() {
        let url = this._baseUrl + 'v1/hub/settings/getAllLang';
        let self = this;
        self._http.get(url).subscribe((result) => {
            self.locals = result;
        }, (error) => {
        });
    }

    public saveData() {
        if (!this.notificationLang.locale || !this.notificationLang.locale.trim()) {
            this._toaster.showError("Select locale");
            return;
        }
        if (!this.notificationLang.messageTemplate
            || !this.notificationLang.messageTemplate.trim()) {
            this._toaster.showError("Message template should not be empty");
            return;
        }
        if (!this.notificationLang.name || !this.notificationLang.name.trim()) {
            this._toaster.showError("Name should not be empty");
            return;
        }

        if (!this.notificationLang.subjectTemplate || !this.notificationLang.subjectTemplate.trim()) {
            this._toaster.showError("Subject template should not be empty");
            return;
        }
        this.triggerSave.emit();
    }

    public cancelEdit() {
        this.cancel.emit();
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/editNotificationLangComponent.ts